import { Link } from 'react-router-dom'
import clsx from 'clsx'

interface Props {
  pages: {
    label: string
    href: string
    active: boolean
  }[]
  survey?: any
}

const SurveyDetailHeader: React.FC<Props> = ({ pages, survey }) => {
  return (
    <div className='card mb-5'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-6'>
          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <span className='text-gray-800 fs-2 fw-bolder me-3'>
                    แบบสำรวจ #{survey?.id ?? '-'}
                  </span>
                </div>
                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <span className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                    หน่วยงาน: {survey?.division || '-'}
                  </span>
                  <span className='d-flex align-items-center text-gray-400 mb-2'>
                    ลูกค้า: {survey?.customerTitle || '-'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap overflow-x-auto'>
            {pages.map(page => (
              <li key={page.label} className='nav-item'>
                <Link
                  className={clsx('nav-link text-active-primary me-6', { active: page.active })}
                  to={page.href}
                  style={{ whiteSpace: 'nowrap' }}>
                  {page.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default SurveyDetailHeader
